import keycloakConfig from "./keycloakConfig";
import Keycloak from "keycloak-js";
import { setSessionCookies, removeSessionCookies } from "../../common/sessions/tokenHelper";
import { clearEnums } from "../../../utils/enums/enumActions";

const TOKEN_MIN_VALIDITY = 240;

let instance;
let keycloakInstance = new Keycloak(keycloakConfig);


class KeycloakManager {
    constructor() {
        if (instance) {
            throw new Error("New instance cannot be created.");
        }
        instance = this;
    }

    async login(accessToken, refreshToken, loginActions) {
        if (accessToken) keycloakInstance.token = accessToken;
        if (refreshToken) keycloakInstance.refreshToken = refreshToken;
        try {
            keycloakInstance
                .init({ onLoad: "check-sso", checkLoginIframe: false, silentCheckSsoFallback: false })
                .then((auth) => {
                    if (auth) {
                        setSessionCookies(keycloakInstance.token, keycloakInstance.refreshToken);
                        loginActions.verifyAuth();
                    } else {
                        keycloakInstance.login();
                    }
                });
        } catch (e) {
            // init() could throw an error if a keycloak instance is already iniatialized
            // This happens at logout, an instance is already initialized and msys login page calls this function
            // In this case we redirect to sso login page
            keycloakInstance.login();
        }
    }
    async initiate(accessToken, refreshToken, callback) {
        keycloakInstance.token = accessToken;
        keycloakInstance.refreshToken = refreshToken;
        try {
            keycloakInstance
                .init({ onLoad: "check-sso", checkLoginIframe: false, silentCheckSsoFallback: false })
                .then((auth) => {
                    if (auth) {
                        setSessionCookies(keycloakInstance.token, keycloakInstance.refreshToken);
                    }
                    callback();
                });
        } catch (e) {
            callback();
        }
    }

    async refreshTokens(accessToken, refreshToken) {
        keycloakInstance.token = accessToken;
        keycloakInstance.refreshToken = refreshToken;
        await keycloakInstance.updateToken(TOKEN_MIN_VALIDITY);
        return [keycloakInstance.token, keycloakInstance.refreshToken];
    }

    async logout(redirectURI=null) {
        clearEnums();
        removeSessionCookies();
        localStorage.removeItem("associatedClientId");
        localStorage.removeItem("languageCode");
        localStorage.removeItem("roleAccess");
        localStorage.removeItem("roleId");

        if (!redirectURI)
            redirectURI = keycloakInstance.createLoginUrl({redirectUri: `${window.location.origin}/dashboard`});
        return keycloakInstance.logout({redirectUri: redirectURI});
    }
}

const keycloakManager = Object.freeze(new KeycloakManager());
export default keycloakManager;



// WEBPACK FOOTER //
// ./src/components/login/sso/keycloakManager.js